import { render } from "./customTag.vue?vue&type=template&id=1b9cd4c4&scoped=true"
import script from "./customTag.vue?vue&type=script&lang=js"
export * from "./customTag.vue?vue&type=script&lang=js"

import "./customTag.vue?vue&type=style&index=0&id=1b9cd4c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b9cd4c4"

export default script